import 'src/styles/normalize.css';

import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { SnackbarProvider } from 'notistack';
import { RecoilRoot } from 'recoil';
import Grow from '@mui/material/Grow';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import Routes from 'src/Routes';

import Snackbar from './components/common/Snackbar';
import Wrapper from './components/Wrapper';
import { systemEnTheme } from './styles/theme';
import { initGA } from './utils/ga';

function Popup() {
  useEffect(() => {
    initGA();
  }, []);

  const theme = createTheme({
    ...systemEnTheme,
  });

  return (
    <ThemeProvider theme={theme}>
      <Wrapper>
        <SnackbarProvider
          Components={{
            success: Snackbar,
            error: Snackbar,
          }}
          maxSnack={3}
          autoHideDuration={null}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          variant="success"
          TransitionComponent={Grow as React.ComponentType}
        >
          <Routes />
        </SnackbarProvider>
      </Wrapper>
    </ThemeProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <RecoilRoot>
      <Popup />
    </RecoilRoot>
  </React.StrictMode>,
);
